module.exports = __webpack_public_path__ + "1cb9bd7a6f694c8ab28b4b5313623919.webp";